import React from 'react';
import { Grid, Card, CardContent, Stack, Typography, Box } from '@mui/material';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

const LeaveStatsCards = ({ stats }) => {
  const statsData = [
    {
      title: 'Total Leaves',
      value: stats?.total_leaves || 0,
      icon: <BeachAccessIcon color="primary" />,
      color: 'primary',
    },
    {
      title: 'Pending',
      value: stats?.pending_leaves || 0,
      icon: <BeachAccessIcon color="warning" />,
      color: 'warning',
    },
    {
      title: 'Approved',
      value: stats?.approved_leaves || 0,
      icon: <BeachAccessIcon color="success" />,
      color: 'success',
    },
    {
      title: 'Rejected',
      value: stats?.rejected_leaves || 0,
      icon: <BeachAccessIcon color="error" />,
      color: 'error',
    },
  ];

  return (
    <>
      {statsData.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={2}>
                {stat.icon}
                <Box>
                  <Typography variant="h4">{stat.value || 0}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {stat.title}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </>
  );
};

export default LeaveStatsCards;
